<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc1">
<h2 class="h2" id="contents"><span epub:type="pagebreak" id="page_5" title="5">Contents</span></h2>
<p class="toc1"><a href="#/xhtml/intro#intro">Introduction</a></p>
<p class="toc"><span href="#/xhtml/ch01#ch01" title="Link target outside of Sample">Chapter 1: Work-Life Balance</span></p>
<p class="toc"><span href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Chapter 2: Daily Rituals</span></p>
<p class="toc"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Chapter 3: Intentions and Goals</span></p>
<p class="toc"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4: Downtime and Creativity</span></p>
<p class="toc11"><span href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?20267a7b